// app/product-advice/[slug]/ViewTracker.tsx
'use client'
import { useEffect } from 'react';

interface ViewTrackerProps {
    adviceId: number;
}

const ViewTracker: React.FC<ViewTrackerProps> = ({ adviceId }) => {
    useEffect(() => {
        const incrementView = async () => {
            try {
                const WP_URL = process.env.NEXT_PUBLIC_WP_URL;

                // Отправляем запрос на увеличение просмотров
                await fetch(`${WP_URL}/wp-json/product-advice/v1/view/${adviceId}`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    }
                });

                console.log(`Просмотр засчитан для совета ID: ${adviceId}`);
            } catch (error) {
                console.error('Ошибка при увеличении просмотров:', error);
            }
        };

        // Задержка перед увеличением просмотров (чтобы убедиться что пользователь реально читает)
        const timer = setTimeout(() => {
            incrementView();
        }, 2000); // 2 секунды

        // Очищаем таймер при размонтировании компонента
        return () => clearTimeout(timer);
    }, [adviceId]);

    // Компонент ничего не рендерит
    return null;
};

export default ViewTracker;